import { useMemo } from 'react';

import { InstanceOperationsName, OperationsName } from '@frontend/types';

import { useOpalUser } from './useOpalUser';

export function useOperations() {
  const { opalUser } = useOpalUser();

  const userOperations = useMemo(
    () => opalUser?.instance?.operations,
    [opalUser?.instance?.operations]
  );

  const instanceOperations = useMemo(
    () => opalUser?.instance?.product_capabilities,
    [opalUser?.instance?.product_capabilities]
  );

  /**
   * Function to check if user has at least one of the required operations.
   * @param operations - list of operations of which at least one is required (checked using Logical OR)
   * @returns boolean indicating if user has at least one of the required operations
   */
  const canUser = (operations: OperationsName[]) => {
    return operations.some(operation => userOperations?.find(p => p.name === operation)?.allowed);
  };

  /**
   * Function to check if instance has all required permissions enabled.
   * @param permissions - list of permissions that must ALL be enabled (checked using Logical AND)
   * @returns boolean indicating if instance has all required permissions enabled
   */
  const canInstance = (permissions: InstanceOperationsName[]) => {
    return permissions.some(
      permission => instanceOperations?.find(p => p.name === permission)?.allowed
    );
  };

  return { operations: userOperations, instanceOperations, canUser, canInstance };
}
